function Header() {
    return (
        <header className="has-background-brown dark has-text-centered">
            <h1 className="title is-1 p-4 has-text-light">Coffee Calc</h1>
        </header>
    )
}

export default Header;